module.exports = __webpack_public_path__ + "statics/img/cate3-1@2x.cfbbf957.png";